import { FC } from 'react';
import BordOneToneIcon from '../../../NudosComponents/BordOneToneIcon/BordOneToneIcon';
import BordTooltip from '../../../BordTooltip/BordTooltip';
import { bordColorTheme } from '../../../../styles/styles.constants';
import { IavailableCountry } from '../../../../types/products';
import './CountryFlagsSection.scss';

interface ICountryFlagsData {
  displayedFlags: JSX.Element[] | null;
  numberOfAdditional: number;
  additionalCountries: IavailableCountry[];
}

interface ICountryFlagsSectionProps {
  storeFlagsData: ICountryFlagsData;
  quoteFlagsData: ICountryFlagsData;
  inactiveFlagsData: ICountryFlagsData;
}

const CountryFlagsSection: FC<ICountryFlagsSectionProps> = ({ storeFlagsData, quoteFlagsData, inactiveFlagsData }) => {
  const renderAdditionalCountriesTooltip = (additionalCountries: IavailableCountry[]) => {
    return (
      <>
        {additionalCountries.map((country, index) => (
          <div key={`additional-country-${index}-${country?.countryCode}`}>
            {country?.countryName || country?.countryCode}
          </div>
        ))}
      </>
    );
  };

  return (
    <div className="countrySectionContainer">
      <div className="countrySectionWithIcon">
        <BordTooltip position="bottomRight" message="Prendido para venta">
          <BordOneToneIcon stroke={bordColorTheme.navyBlue[500]} variant="shoppingCart" standardSize={10} />
        </BordTooltip>
        <div className="countryFlagsContainer">{storeFlagsData?.displayedFlags}</div>
        {!storeFlagsData?.displayedFlags?.length && (
          <span className="numberOfFlags">{storeFlagsData?.displayedFlags?.length || 0}</span>
        )}
        {!!storeFlagsData?.numberOfAdditional && (
          <BordTooltip
            position="bottomLeft"
            message={renderAdditionalCountriesTooltip(storeFlagsData?.additionalCountries)}
          >
            <span className="additionalCountries">+{storeFlagsData?.numberOfAdditional}</span>
          </BordTooltip>
        )}
      </div>
      <div className="dividerLine"></div>
      <div className="countrySectionWithIcon">
        <BordTooltip position="bottomRight" message="Prendido para cotizar">
          <BordOneToneIcon stroke="currentColor" variant="document" standardSize={10} />
        </BordTooltip>
        <div className="countryFlagsContainer">{quoteFlagsData?.displayedFlags}</div>
        {!quoteFlagsData?.displayedFlags?.length && (
          <span className="numberOfFlags">{quoteFlagsData?.displayedFlags?.length || 0}</span>
        )}
        {!!quoteFlagsData?.numberOfAdditional && (
          <BordTooltip
            position="bottomLeft"
            message={renderAdditionalCountriesTooltip(quoteFlagsData?.additionalCountries)}
          >
            <span className="additionalCountries">+{quoteFlagsData?.numberOfAdditional}</span>
          </BordTooltip>
        )}
      </div>
      <div className="dividerLine"></div>
      <div className="countrySectionWithIcon">
        <BordTooltip position="bottomRight" message="Apagado">
          <BordOneToneIcon stroke="currentColor" variant="eyeOff" standardSize={10} />
        </BordTooltip>
        <div className="countryFlagsContainer">{inactiveFlagsData?.displayedFlags}</div>
        {!inactiveFlagsData?.displayedFlags?.length && (
          <span className="numberOfFlags">{inactiveFlagsData?.displayedFlags?.length || 0}</span>
        )}
        {!!inactiveFlagsData?.numberOfAdditional && (
          <BordTooltip
            position="bottomLeft"
            message={renderAdditionalCountriesTooltip(inactiveFlagsData?.additionalCountries)}
          >
            <span className="additionalCountries">+{inactiveFlagsData?.numberOfAdditional}</span>
          </BordTooltip>
        )}
      </div>
    </div>
  );
};

export default CountryFlagsSection;
